"use client"

import * as React from "react"

type SlotProps = React.HTMLAttributes<HTMLElement> & {
  children?: React.ReactNode
  asChild?: boolean
}

const Slot = React.forwardRef<HTMLElement, SlotProps>(
  ({ children, asChild = false, ...props }, ref) => {
    if (asChild && React.isValidElement(children)) {
      return React.cloneElement(children, {
        ...props,
        ...children.props,
        ref: ref
          ? (mergedRef: HTMLElement) => {
              if (typeof ref === "function") ref(mergedRef)
              else if (ref) ref.current = mergedRef

              const { ref: childRef } = children as any
              if (typeof childRef === "function") childRef(mergedRef)
              else if (childRef) childRef.current = mergedRef
            }
          : children.props.ref,
      })
    }

    return (
      <span ref={ref as React.RefObject<HTMLSpanElement>} {...props}>
        {children}
      </span>
    )
  }
)

Slot.displayName = "Slot"

export { Slot } 